<template>
  <div>
    <div class="list">
      <div v-for="item in list" :key="item.id" class="list_item">
        <div class="check_info">
          <div class="check_time">
            检票时间：{{ item.checkTime }}
            <span class="lucky" v-if="item.isLucky === 1">【幸运纪念】</span>
          </div>
          <div>参观人：{{ item.name }}</div>
          <div>
            当天入馆位次：{{ item.todayCount
            }}<span v-if="item.luckyCondition?.includes('今日位次')"
              >【幸运纪念】</span
            >
          </div>
          <div>
            年度入馆位次：{{ item.yearCount
            }}<span v-if="item.luckyCondition?.includes('本年位次')"
              >【幸运纪念】</span
            >
          </div>
          <div>
            历史入馆位次：{{ item.historyCount
            }}<span v-if="item.luckyCondition?.includes('历史位次')"
              >【幸运纪念】</span
            >
          </div>
          <div>
            参观次数：{{ item.myCount
            }}<span v-if="item.luckyCondition?.includes('来馆次数')"
              >【幸运纪念】</span
            >
          </div>
        </div>
        <div class="bnts">
          <div @click="scanQrcode(item)">二维码</div>
          <div @click="viewPoster(item)" v-if="item.isLucky === 1">
            查看海报
          </div>
        </div>
      </div>
      <div v-show="list.length === 0" class="nothing">
        <img src="@/assets/images/nothing.png" alt="" />
        <span>暂无数据</span>
      </div>
    </div>
    <van-dialog
      v-model:show="show"
      class="member"
      :showConfirmButton="false"
      :closeOnClickOverlay="false"
    >
      <img class="bg" src="@/assets/images/member.png" alt="" />
      <img :src="qrcode" alt="" class="qrCode" />
      <div class="close" @click="show = false"></div>
    </van-dialog>
  </div>
</template>

<script>
import { entryRecordList, qrcode } from "@/api/Poster";

export default {
  data() {
    return {
      list: [],
      show: false,
      qrcode: "",
    };
  },

  name: "list",
  components: {},

  created() {
    entryRecordList().then((res) => {
      this.list = res.rows || [];
    });
  },

  mounted() {},

  methods: {
    scanQrcode(item) {
      qrcode(item.id).then((res) => {
        this.show = true;
        this.qrcode = "data:image/png;base64," + res.data.img;
      });
    },
    viewPoster(item) {
      this.$router.push({
        path: "/ActivityPoster",
        query: {
          type: Math.floor(Math.random() * 3) + 1,
          data: JSON.stringify({
            name: item.name,
            checkTime: item.checkTime,
            todayCount: item.todayCount,
            yearCount: item.yearCount,
            historyCount: item.historyCount,
            myCount: item.myCount,
          }),
        },
      });
    },
  },

  computed: {},
};
</script>
<style lang="scss" scoped>
.list {
  background: #f5f6fa;
  min-height: calc(100vh - 1.227rem);
}
.list_item {
  font-size: 14px;
  margin-bottom: 20px;
  padding: 20px;
  // border: 1px solid #e5e5e5;
  border-radius: 5px;
  background-color: #fff;
  .check_time {
    font-size: 14px;
    font-weight: bold;
    display: flex;

    justify-content: space-between;
  }
  .lucky {
    color: #ff4d4f;
  }
  .check_info {
    color: #333;
    margin-bottom: 10px;
    border-bottom: 1px solid #e5e5e5;
    > div {
      margin-bottom: 10px;
      span {
        font-size: 14px;
        font-weight: bold;
        color: #ff4d4f;
      }
    }
  }
  .bnts {
    display: flex;
    justify-content: flex-end;
    > div {
      font-size: 14px;
      margin-left: 10px;
      border: 1px solid #007bff;
      color: #007bff;
      padding: 5px 10px;
    }
  }
}
::v-deep .member {
  background-color: transparent;
  .van-dialog__content {
    position: relative;
    .bg {
      width: 300px;
    }
    .qrCode {
      width: 180px;
      position: absolute;
      left: 0;
      right: 0;
      top: 100px;
      margin: auto;
    }
    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      left: 0;
      right: 20px;
      margin: 0 auto;
      bottom: 5px;
    }
  }
}
.nothing {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  img {
    width: 60%;
  }
  span {
    font-size: 16px;
    color: #999;
  }
}
</style>
